module.exports = __webpack_public_path__ + "static/how-to-create-contest__step-3-89aa9987a97378db24cadf787c926ee7.png";